import React, { useEffect } from "react";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../../widget/common/ui/MainContainer";
import SignupPersonalLogoUploadButtons from "./widget/SignupPersonalLogoUploadButtons";
import SignupPersonalLogoUploadContent from "./SignupPersonalLogoUploadContent";
import StorageKeys from "../../../../const/StorageKeys";
import UtilityHelper from "../../../../service/utilities/UtilityHelper";
import { appRoutes } from "../../../../routes/routes";
import SessionStorage from "../../../../service/storage/SessionStorage";
import { navigate } from "../../../../service/navigation/Navigation";
import { SignupAccountVerificationContextProvider } from "../../../../provider/onboarding/signup/account_verification/SignupAccountVerificationContextProvider";
import AppConfigService from "../../../../service/app_config/AppConfigService";

const SignupPersonalLogoUploadScreen = () => {
  const type: number = ResponsiveDeviceType();

  const checkVericationSession = () => {
    const accountIdSession = SessionStorage.getValue(StorageKeys.account_id);
    if (UtilityHelper.isEmpty(accountIdSession)) {
      navigate(appRoutes.routeNameLogin, { replace: true });
    }
  };

  useEffect(() => {
    checkVericationSession();
  }, []);

  return (
    <SignupAccountVerificationContextProvider>
      <Scaffold
        appBarTitle={
          type === 3 ? undefined : AppConfigService.get("company_name")
        }
        bottomNavigationButton={<SignupPersonalLogoUploadButtons />}
        disabledBack={true}
      >
        <MainBodyContainer>
          <SignupPersonalLogoUploadContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </SignupAccountVerificationContextProvider>
  );
};

export default SignupPersonalLogoUploadScreen;
export const routeName: string = "/signup/personal-logo-upload";
